// Standalone /play-engine page — the Play Engine brief. Routed at the top level in index.js
// (same pattern as /data-dictionary and /privacy-policy), so it renders outside the app shell.
// The content is the self-contained static doc in public/play-engine.html; we embed it in a
// full-viewport iframe so its page-level styles stay fully isolated.
export default function PlayEngine() {
  return (
    <iframe
      title="Pollis — The Play Engine"
      src={`${process.env.PUBLIC_URL || ""}/play-engine.html`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
